import { Tabs } from "antd";
import { useState } from "react";
import type { UUID } from "../../../../../typings/global";
import { AgentTypeTag } from "../../../../agent/components/tags/AgentTypeTag";
import { formatAgentAggregatedName } from "../../../../agent/utils";
import { AgentUserProfile } from "../../../types";

interface Props {
  userProfile: AgentUserProfile;
  title: string;
  component: (agentId: UUID) => React.JSX.Element;
}

const UserProfileAgentTabSwitchView = ({ userProfile, title, component }: Props) => {
  const [agentId, setAgentId] = useState<UUID>(userProfile.agent?.id ?? "");

  return userProfile.agent && userProfile.representingAgent ? (
    <>
      <h2>{title}</h2>
      <Tabs
        activeKey={agentId}
        onChange={setAgentId}
        destroyOnHidden
        items={[
          {
            key: userProfile.agent?.id,
            label: (
              <>
                {formatAgentAggregatedName(userProfile.agent)}
                <AgentTypeTag style={{ marginLeft: 8 }} type={userProfile.agent.type} />
              </>
            ),
            children: component(agentId),
          },
          {
            key: userProfile.representingAgent.id,
            label: (
              <>
                {formatAgentAggregatedName(userProfile.representingAgent)}
                <AgentTypeTag style={{ marginLeft: 8 }} type={userProfile.representingAgent.type} />
              </>
            ),
            children: component(agentId),
          },
        ]}
      />
    </>
  ) : (
    <>
      <h2>
        {title} | {formatAgentAggregatedName(userProfile.agent)}
      </h2>
      {component(agentId)}
    </>
  );
};

export default UserProfileAgentTabSwitchView;
